<template>
  <Box>
    <template #handle>
      <Btn @click="$router.go(-1)">返回</Btn>
    </template>
    <template #content>
      <div class="table_main">
        <div class="content">
          <Table :datas="tableData" :heads="tableHead" :selection="false" :loading="loading">
            <template #handle="data">
              <div class="table_cell">
                <span v-if="data.head.handle == 'index'">{{
                (pageData.page - 1) * pageData.pageSize + data.index
                }}</span>
                <span v-if="data.head.handle == 'status'" :class="['pre']">
                  <span class="_pre" :style="{
                    background: (
                      sbstate.find((a) => a.value == data.data.sbstate) || {}
                    ).color,
                  }"></span>
                  <span>{{ data.data.sbstate }}</span>
                </span>
                <div v-if="data.head.handle == 'btns'">
                  <Btn type="text" v-if="hasPermi('system:lscs:query')" @click="handleItem(data.data, '参数详情')">参数详情</Btn>
                </div>
              </div>
            </template>
          </Table>
          <el-pagination class="page" background layout="total, sizes, prev, pager, next" :total="pageData.total" :page-sizes = "[10, 20, 50, 100]"
            :current-page.sync="pageData.page" :page-size.sync="pageData.pageSize" @size-change="query" @current-change="getList">
          </el-pagination>
        </div>
      </div>
      <Drawer :open="open" @changeOpen="changeOpen" :title="drawerTitle" :width="830">
        <template #content>
          <el-form :model="addForm" ref="addForm" :rules="rules" label-width="180px" :class="[
            'demo-ruleForm',
            'formBox',
            disabledTitles.includes(drawerTitle) ? 'disabled' : '',
          ]" :disabled="disabledTitles.includes(drawerTitle)">
            <div class="inTitle">外设参数1</div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="电子称IP地址：" prop="LectronicWeigherIP">
                  <el-input size="small" v-model="addForm.LectronicWeigherIP"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电子秤端口号：" prop="LectronicWeigherIPPort">
                  <el-input-number size="small" v-model.number="addForm.LectronicWeigherIPPort"
                    controls-position="right" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="电子秤型号：" prop="LectronicWeigherModel">
                  <el-select size="small" v-model="addForm.LectronicWeigherModel">
                    <el-option v-for="item in euipData" :key="`${item.id}`" :label="item.xhname" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="自动采集模块IP地址：" prop="PhotoelectricDeviceIP">
                      <el-input size="small" v-model="addForm.PhotoelectricDeviceIP"></el-input>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="自动采集模块端口：" prop="PhotoelectricDeviceIPPort">
                      <el-input-number size="small" v-model.number="addForm.PhotoelectricDeviceIPPort" controls-position="right" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="刷唛设备IP地址：" prop="BranderIP">
                      <el-input size="small" v-model="addForm.BranderIP"></el-input>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="刷唛设备端口：" prop="BranderPort">
                      <el-input-number size="small" v-model.number="addForm.BranderPort" controls-position="right" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="刷唛类型：" prop="BrandModel">
                      <el-select size="small" v-model="addForm.BrandModel">
                          <el-option v-for="item in BrandModels" :key="`${item.value}`" :label="item.label"
                                     :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="定位模块串口号：" prop="GPSModuleCOM">
                      <el-select size="small" v-model="addForm.GPSModuleCOM">
                          <el-option v-for="item in com1_9" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
<!--                <el-form-item label="刷唛机模块串口号：" prop="BranderCOM">-->
<!--                  <el-select size="small" v-model="addForm.BranderCOM">-->
<!--                    <el-option v-for="item in com1_9" :key="item.value" :label="item.label" :value="item.value">-->
<!--                    </el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->
                  <el-form-item label="压花机模块串口号：" prop="EmbosserCOM">
                      <el-select size="small" v-model="addForm.EmbosserCOM">
                          <el-option v-for="item in com1_9" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="电源控制器串口号：" prop="PowerControlCOM">
                        <el-select size="small" v-model="addForm.PowerControlCOM">
                            <el-option v-for="item in com1_9" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="定位模块波特率：" prop="GPSBaudRate">
                        <el-select size="small" v-model="addForm.GPSBaudRate">
                            <el-option v-for="item in baudRate" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="压花机模块波特率：" prop="EmbosserBaudRate">
                        <el-select size="small" v-model="addForm.EmbosserBaudRate">
                            <el-option v-for="item in baudRate" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="电源控制器波特率：" prop="PowerControlBaudRate">
                        <el-select size="small" v-model="addForm.PowerControlBaudRate">
                            <el-option v-for="item in baudRate" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="inTitle">外设参数2</div>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="回潮仪IP地址：" prop="MoistureMeterIP">
                      <el-input size="small" v-model="addForm.MoistureMeterIP"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="回潮仪端口：" prop="MoistureMeterIPPort">
                      <el-input-number size="small" v-model.number="addForm.MoistureMeterIPPort" controls-position="right" />
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="外挂屏IP地址：" prop="ScreenIP">
                      <el-input size="small" v-model="addForm.ScreenIP"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="外挂屏端口：" prop="ScreenPort">
                      <el-input-number size="small" v-model.number="addForm.ScreenPort" controls-position="right" />
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="外挂屏型号：" prop="ScreenModel">
                      <el-select size="small" v-model="addForm.ScreenModel">
                          <el-option v-for="item in ScreenModels" :key="`ScreenModels${item.value}`" :label="item.label"
                                     :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="12">

              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="外接屏内容类型：" prop="ScreenContentType">
                  <el-radio-group size="small" v-model="addForm.ScreenContentType">
                    <el-radio label="生产参数">生产参数</el-radio>
                    <el-radio label="自定义内容">自定义内容</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="外接屏幕滚动设置：" prop="ScreenScrollWay">
                  <el-select size="small" v-model="addForm.ScreenScrollWay">
                    <el-option v-for="item in ScreenScrollWays" :key="`ScreenScrollWay${item.value}`"
                      :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item v-if="addForm.ScreenContentType == '自定义内容'" label="自定义内容：" prop="ScreenCustomContent">
                  <el-input type="textarea" size="small" v-model="addForm.ScreenCustomContent"></el-input>
                </el-form-item>
                <el-form-item v-else label="生产参数：">
                  <div class="pl10">
                    <el-checkbox v-model="addForm.ScreenContentBaleNo">包号</el-checkbox>
                    <el-checkbox v-model="addForm.ScreenContentSeedCottonLevel">籽棉等级</el-checkbox>
                    <el-checkbox v-model="addForm.ScreenContentNet">净重</el-checkbox>
                    <el-checkbox v-model="addForm.ScreenContentTare">皮重</el-checkbox>
                    <el-checkbox v-model="addForm.ScreenContentReturnHumidityCate">回潮率</el-checkbox>
                    <el-checkbox v-model="addForm.ScreenContentProcessingType">加工类型</el-checkbox>
                    <el-checkbox v-model="addForm.ScreenContentProcessingBatchNumber">当前加工批号</el-checkbox>
                      <el-checkbox v-model="addForm.ScreenContentTraceNo">追溯卡号</el-checkbox>
                      <el-checkbox v-model="addForm.ScreenContentFarmerInfo">棉农信息</el-checkbox>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="inTitle">生产参数</div>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="棉花品种：" prop="CottonKind">
                      <el-input size="small" v-model="addForm.CottonKind"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="异性纤维：" prop="ForeignFiber">
                      <el-select size="small" v-model="addForm.ForeignFiber">
                          <el-option v-for="item in ForeignFibers" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="加工类型权限：" prop="ProcessingTypeAuth">
                      <el-select size="small" v-model="addForm.ProcessingTypeAuth">
                          <el-option v-for="item in ProcessingTypeAuths" :key="item.value" :label="item.label"
                                     :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="加工类型：" prop="ProcessingType">
                      <el-select size="small" v-model="addForm.ProcessingType">
                          <el-option v-for="item in (
                      ProcessingTypeAuths.find(
                        (a) => a.value == addForm.ProcessingTypeAuth
                      ) || { children: [] }
                    ).children" :key="`ProcessingType${item}`" :label="jglx.find((a) => a.value == item).label"
                                     :value="item">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="加工批号：" prop="BatchNo">
                      <el-input-number size="small" v-model.number="addForm.BatchNo" controls-position="right" :min="1" :max="999" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="包号：" prop="BaleNo">
                      <el-input size="small" v-model="addForm.BaleNo"></el-input>
                  </el-form-item>
              </el-col>
            </el-row>
<!--            <div class="inTitle">刷唛配置</div>-->
<!--            <el-row :gutter="20">-->
<!--              <el-col :span="12">-->
<!--                  <el-form-item label="销售模式：" prop="SalesModel">-->
<!--                      <el-select size="small" v-model="addForm.SalesModel">-->
<!--                          <el-option v-for="item in SalesModels" :key="`${item.value}`" :label="item.label" :value="item.value"></el-option>-->
<!--                      </el-select>-->
<!--                  </el-form-item>-->
<!--              </el-col>-->
<!--              <el-col :span="12">-->
<!--                  <el-form-item label="产品类型：" prop="ProductType">-->
<!--                      <el-select size="small" v-model="addForm.ProductType">-->
<!--                          <el-option v-for="item in ProductTypes" :key="`${item.value}`" :label="item.label" :value="item.value"></el-option>-->
<!--                      </el-select>-->
<!--                  </el-form-item>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--            <el-row :gutter="20">-->
<!--              <el-col :span="12">-->
<!--                  <el-form-item label="控制器类型：" prop="ControllerType">-->
<!--                      <el-select size="small" v-model="addForm.ControllerType">-->
<!--                          <el-option v-for="item in ControllerTypes" :key="`${item.value}`" :label="item.label" :value="item.value"></el-option>-->
<!--                      </el-select>-->
<!--                  </el-form-item>-->
<!--              </el-col>-->
<!--              <el-col :span="12">-->
<!--                  <el-form-item label="是否刷唛：" prop="IsBrand">-->
<!--                      <el-select size="small" v-model="addForm.IsBrand">-->
<!--                          <el-option v-for="item in IsBrands" :key="`IsBrand${item.value}`" :label="item.label" :value="item.value"></el-option>-->
<!--                      </el-select>-->
<!--                  </el-form-item>-->
<!--              </el-col>-->
<!--            </el-row>-->
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="垛号：" prop="CribNo">
                      <el-select size="small" v-model="addForm.CribNo">
                          <el-option v-for="item in CribNos" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="籽棉等级：" prop="SeedCottonLevel">
                      <el-input-number size="small" v-model.number="addForm.SeedCottonLevel" controls-position="right" :min="1" :max="9" />
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="每批包数：" prop="BatchBaleCount">
                      <el-input-number size="small" v-model.number="addForm.BatchBaleCount" controls-position="right" :min="100" :max="999" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="皮重：" prop="Tare">
                      <el-input-number size="small" v-model.number="addForm.Tare" controls-position="right" />
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="满包数批号+1：" prop="BatchBaleCountPlusOne">
                      <el-select size="small" v-model="addForm.BatchBaleCountPlusOne">
                          <el-option v-for="item in BatchBaleCountPlusOnes" :key="`BatchBaleCountPlusOne${item.value}`"
                                     :label="item.label" :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="同时打印追溯卡号数：" prop="SamePrintCottonMoldCount">
                      <el-select size="small" v-model="addForm.SamePrintCottonMoldCount">
                          <el-option v-for="item in SamePrintCottonMoldCounts" :key="item.value" :label="item.label"
                                     :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="离线后可工作时间：" prop="OffLineCanWorkHour">
                      <el-input-number size="small" v-model.number="addForm.OffLineCanWorkHour" controls-position="right" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="离线锁定时间：" prop="OffLineLockDay">
                      <el-input-number size="small" v-model.number="addForm.OffLineLockDay" controls-position="right" />
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="卷标号剩余数量警告下限：" prop="ExistingVolumeLabelNoWarningFloor">
                      <el-input-number size="small" v-model.number="addForm.ExistingVolumeLabelNoWarningFloor" controls-position="right" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">

              </el-col>
            </el-row>
            <div class="inTitle">其它参数</div>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="最大包重：" prop="MaxBaleWeight">
                      <el-input size="small" v-model.trim="addForm.MaxBaleWeight">
                          <template slot="append">Kg</template>
                      </el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="最小包重：" prop="MinBaleWeight">
                      <el-input size="small" v-model.trim="addForm.MinBaleWeight">
                          <template slot="append">Kg</template>
                      </el-input>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="最大回潮：" prop="MaxReturnHumidity">
                      <el-input size="small" v-model.trim="addForm.MaxReturnHumidity">
                          <template slot="append">%</template>
                      </el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="最小回潮：" prop="MinReturnHumidity">
                      <el-input size="small" v-model.trim="addForm.MinReturnHumidity">
                          <template slot="append">%</template>
                      </el-input>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="打印色深：" prop="PrintColorDepth">
                      <el-input-number size="small" v-model.number="addForm.PrintColorDepth" controls-position="right" :min="20" :max="30" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="打印速度：" prop="PrintSpeed">
                      <el-input-number size="small" v-model.number="addForm.PrintSpeed" controls-position="right" :min="2" :max="10" />
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
                  <el-col :span="12">
                      <el-form-item label="裁切线偏移量：" prop="PaperCuttingMode">
                          <el-input-number size="small" v-model.number="addForm.PaperCuttingMode" controls-position="right" />
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">
                      <el-form-item label="加电操作：" prop="PowerMode">
                          <el-select size="small" v-model="addForm.PowerMode">
                              <el-option v-for="item in powerModes" :key="`${item.value}`" :label="item.label"
                                         :value="item.value">
                              </el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="采集最小间隔：" prop="CollectDurationVal" >
                      <el-input-number size="small" v-model.number="addForm.CollectDurationVal" controls-position="right" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="采集间隔值上限：" prop="CollectDurationUpper" >
                      <el-input-number size="small" v-model.number="addForm.CollectDurationUpper" controls-position="right" />
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="采集间隔值下限：" prop="CollectDurationLower" >
                      <el-input-number size="small" v-model.number="addForm.CollectDurationLower" controls-position="right" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="是否开启自动加热：" prop="HeatupState">
                      <el-select size="small" v-model="addForm.HeatupState">
                          <el-option v-for="item in heatups" :key="`${item.value}`" :label="item.label"
                                     :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="加热阈值上限：" prop="HeatupTempUpper" >
                      <el-input-number size="small" v-model.number="addForm.HeatupTempUpper" controls-position="right" />
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="加热阈值下限：" prop="HeatupTempLower" >
                      <el-input-number size="small" v-model.number="addForm.HeatupTempLower" controls-position="right" />
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                  <el-form-item label="加工年度：" prop="Year">
                      <el-input size="small" v-model="addForm.Year" disabled></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                  <el-form-item label="生产线编号：" prop="sccode">
                      <el-input size="small" v-model="addForm.sccode" disabled></el-input>
                  </el-form-item>
              </el-col>
            </el-row>
            <div class="inTitle">排班信息</div>
            <el-row :gutter="20">
              <el-col :span="24">
                <Table :datas="addForm.ShiftInfos" :heads="innerTableHead" :selection="false">
                  <template #handle="data">
                    <span v-if="
                      data.head.handle == 'Shift' &&
                      disabledTitles.includes(drawerTitle)
                    ">
                      {{ data.data.Shift }}
                    </span>
                    <el-select v-if="
                      data.head.handle == 'Shift' &&
                      !disabledTitles.includes(drawerTitle)
                    " size="small" v-model="data.data.Shift">
                      <el-option v-for="item in Shifts" :key="`Shifts${item}`" :label="item" :value="item">
                      </el-option>
                    </el-select>
                    <span v-if="data.head.handle == 'BeginTime' || data.head.handle == 'EndTime'">{{
                    data.head.handle == 'BeginTime'?data.data.BeginTime.split(' ')[1]:data.data.EndTime.split(' ')[1]
                    }}</span>
                    <el-input v-if="data.head.handle == 'ShiftLeader'" size="small" v-model="data.data.ShiftLeader" />
                  </template>
                </Table>
              </el-col>
            </el-row>
          </el-form>
        </template>
        <template #footer v-if="!disabledTitles.includes(drawerTitle)">
          <Btn type="blue" @click="commitData">提交</Btn>
          <Btn @click="closeDrawer">取消</Btn>
        </template>
      </Drawer>
    </template>
  </Box>
</template>

<script>
import {
    sbstate,
    CribNos,
    ScreenScrollWays,
    LectronicWeigherModels,
    TraceModes,
    ScreenModels,
    SamePrintCottonMoldCounts,
    ForeignFibers,
    ProcessingTypeAuths,
    BrandModels,
    BatchBaleCountPlusOnes,
    Shifts,
    jglx,
    com1_9, SalesModels, ProductTypes, ControllerTypes, IsBrands, baudRate, heatups,powerModes
} from "@/utils/status";
import drawerMixins from "@/components/drawer/drawer";
import {
  sbLscsList,
  lscs,
  parameterSynchronization,
  printerReset,
  euipmentQueryDzc,
} from "@/api/ParamsSetAndSync";
import rules from "@/utils/formRules";
import permMixin from "@/mixins/perm";
export default {
  mixins: [drawerMixins, permMixin],
  data() {
    return {
      sbstate,
      BrandModels,
      SalesModels,
      ProductTypes,
      ControllerTypes,
      IsBrands,
      ScreenModels,
      com1_9,
      baudRate,
      heatups,
      powerModes,
      CribNos,
      ForeignFibers,
      SamePrintCottonMoldCounts,
      ProcessingTypeAuths,
      BatchBaleCountPlusOnes,
      LectronicWeigherModels,
      TraceModes,
      Shifts,
      ScreenScrollWays,
      jglx,
      sbstate,
      disabledTitles: ["参数详情"],
      drawerTitle: "详情",
      ywryData: [],
      tableData: [],
      Year: "",
      rules: {
        LectronicWeigherIP: rules.LectronicWeigherIP,
        LectronicWeigherIPPort: rules.hostaddress,
      },
      tableHead: [
        {
          prop: "xh",
          label: "序号",
          handle: "index",
          width: 50,
          textAlign: "center",
        },
        {
          label: "省",
          prop: "province",
        },
        {
          label: "市",
          minWidth: 100,
          prop: "city",
        },
        {
          label: "区",
          prop: "area",
        },
        {
          label: "企业名称",
          minWidth: 200,
          prop: "companyname",
        },
        {
          label: "生产线",
          prop: "sccode",
          textAlign: "center",
        },
        {
          prop: "cz",
          label: "操作",
          handle: "btns",
          width: 120,
          fixed: "right",
        },
      ],
      innerTableHead: [
        {
          prop: "Shift",
          label: "班次",
          handle: "Shift",
        },
        {
          prop: "BeginTime",
          label: "开始时间",
          handle: 'BeginTime'
        },
        {
          prop: "EndTime",
          label: "结束时间",
          handle: 'EndTime'
        },
        {
          prop: "ShiftLeader",
          label: "带班人",
        },
      ],
      tableSelected: [],
      addForm: {
        LectronicWeigherIP: "",
        LectronicWeigherIPPort: 0,
        MoistureMeterIP: "",
        MoistureMeterIPPort: 0,
        ScreenIP: "",
        ScreenPort: 0,
        PhotoelectricDeviceIP: "",
        PhotoelectricDeviceIPPort: 0,
        BranderIP: "192.168.1.207",
        BranderPort: 8899,
        BranderCOM: "COM2",
        PowerControlCOM: "COM4",
        GPSModuleCOM: "COM1",
        EmbosserCOM: "COM3",
        GPSBaudRate: 9600,
        EmbosserBaudRate: 9600,
        PowerControlBaudRate: 9600,
        PrintColorDepth: 20,
        PrintSpeed: 2,
        ScreenModel: "0",
        ScreenScrollWay: 0,
        ScreenContentType: "生产参数",
        ScreenContentBaleNo: false,
        tentSeedCottonLevel: false,
        ScreenContentNet: false,
        ScreenContentTare: false,
        ScreenContentReturnHumidityCate: false,
        ScreenContentProcessingType: false,
        ScreenContentProcessingBatchNumber: false,
        ScreenContentTraceNo: false,
        ScreenContentFarmerInfo: true,
        MaxBaleWeight: 0,
        MinBaleWeight: 0,
        MaxReturnHumidity: "",
        MinReturnHumidity: "",
        ExistingVolumeLabelNoWarningFloor: 0,
        Year: "",
        BatchNo: 1,
        sccode: "",
        SalesModel: "",
        ProductType: "",
        ControllerType: "",
        IsBrand: true,
        CottonKind: "000",
        Tare: 0,
        BaleNo: "0",
        CribNo: 1,
        ForeignFiber: 1,
        SamePrintCottonMoldCount: 0,
        SeedCottonLevel: 0,
        ProcessingTypeAuth: 0,
        ProcessingType: 0,
        BatchBaleCount: 0,
        BatchBaleCountPlusOne: true,
        PrintXOffset: 0,
        PrintCottonMoldNoSwitch: true,
        TraceMode: 0,
        BrandModel: "",
        OffLineCanWorkHour: 240,
        OffLineLockDay: 2,
        CollectDurationVal: 120,
        CollectDurationUpper: 600,
        CollectDurationLower: 10,
        HeatupState: 0,
        HeatupTempLower: 20,
        HeatupTempUpper: 30,
        StartStopThreshold: 0,
        ScreenSwitch: true,
        ScreenContentSeedCottonLevel: true,
        LectronicWeigherModel: 0,
        ShiftInfos: [],
        PowerMode:null,
      },
      initAddForm: {
        LectronicWeigherIP: "",
        LectronicWeigherIPPort: 0,
        MoistureMeterIP: "",
        MoistureMeterIPPort: 0,
        ScreenIP: "",
        ScreenPort: 0,
        PhotoelectricDeviceIP: "",
        PhotoelectricDeviceIPPort: 0,
        BranderIP: "192.168.1.207",
        BranderPort: 8899,
        BranderCOM: "COM2",
        PowerControlCOM: "COM4",
        GPSModuleCOM: "COM1",
        EmbosserCOM: "COM3",
        GPSBaudRate: 9600,
        EmbosserBaudRate: 9600,
        PowerControlBaudRate: 9600,
        PrintColorDepth: 20,
        PrintSpeed: 2,
        ScreenModel: "0",
        ScreenScrollWay: 0,
        ScreenContentType: "生产参数",
        ScreenContentBaleNo: false,
        ScreenContentSeedCottonLevel: false,
        ScreenContentNet: false,
        ScreenContentTare: false,
        ScreenContentReturnHumidityCate: false,
        ScreenContentProcessingType: false,
        ScreenContentProcessingBatchNumber: false,
        MaxBaleWeight: 0,
        MinBaleWeight: 0,
        MaxReturnHumidity: "",
        MinReturnHumidity: "",
        ExistingVolumeLabelNoWarningFloor: 0,
        Year: "",
        BatchNo: 1,
        sccode: "",
        SalesModel: "",
        ProductType: "",
        ControllerType: "",
        IsBrand: true,
        CottonKind: "000",
        Tare: 0,
        BaleNo: "0",
        CribNo: 1,
        ForeignFiber: 1,
        SamePrintCottonMoldCount: 0,
        SeedCottonLevel: 0,
        ProcessingTypeAuth: 0,
        ProcessingType: 0,
        BatchBaleCount: 0,
        BatchBaleCountPlusOne: true,
        PrintXOffset: 0,
        PrintCottonMoldNoSwitch: true,
        TraceMode: 0,
        BrandModel: "",
        OffLineCanWorkHour: 240,
        OffLineLockDay: 2,
        CollectDurationVal: 120,
        CollectDurationUpper: 600,
        CollectDurationLower: 10,
        HeatupState: 0,
        HeatupTempLower: 20,
        HeatupTempUpper: 30,
        StartStopThreshold: 0,
        ScreenSwitch: true,
        ScreenContentSeedCottonLevel: true,
        LectronicWeigherModel: 0,
        ShiftInfos: [],
      },
      euipData: [],
      loading: false,
      pageData: {
        total: 0,
        page: 1,
        pageSize: 10,
      },
    };
  },
  methods: {
    initDMJ(data) {
      this.$confirm("确认重置打码机", "打码机重置", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        printerReset(data.sbid).then((res) => {
          this.$message.success(res.msg);
        });
      });
    },
    getDuipData() {
      euipmentQueryDzc().then((res) => {
        this.euipData = res.data;
      });
    },
    async handleItem(data, drawerTitle) {
      this.drawerTitle = drawerTitle;
      this.addForm = {
        ...this.initAddForm,
      };
      await lscs(data.id).then((res) => {
        if (res.data.csxq) {
          this.addForm = JSON.parse(res.data.csxq);
          if (this.addForm.Year == 0) this.addForm.Year = "";
          this.addForm.id = res.data.id;
          this.addForm.sbid = res.data.sbid;
          this.changeOpen();
        } else {
          this.$message.error('数据库csxq节点出错了，请联系管理员')
        }
      });
    },
    async commitData() {
      const params = {
        id: this.addForm.id,
        sbid: this.addForm.sbid,
      };
      const csxq = Object.assign({}, this.addForm);
      delete csxq.id;
      delete csxq.sbid;
      if (csxq.Year == "") csxq.Year = 0;
      params.csxq = JSON.stringify(csxq);
      await parameterSynchronization(params).then(() => {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.changeOpen();
        this.getList();
      });
      this.addForm = {
        ...this.initAddForm,
      };
    },
    initQuery() {
      this.pageData.page = 1;
      this.$refs.query_form.resetFields();
    },
    query() {
      this.pageData.page = 1;
      this.getList();
    },
    getList() {
      if (!this.$route.query.sbId) return;
      this.loading = true
      const params = {
        id: this.$route.query.sbId,
        currentPage: this.pageData.page,
        pageSize: this.pageData.pageSize
      };
      sbLscsList(params)
        .then((res) => {
          this.pageData.total = res.data.count;
          this.tableData = res.data?.list || [];
          this.loading = false
        })
        .catch((err) => {
          this.pageData.total = 0;
          this.tableData = [];
          this.loading = false
        });
    },
    toPath(path, data) {
      if (!data.sbid) return;
      this.$router.push({
        path,
        query: {
          sbId: data.sbid,
        },
      });
    },
  },
  created() {
    this.getDuipData();
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-form-item__label {
    white-space: nowrap;
  }
}
</style>
